module.exports = __webpack_public_path__ + "img/spgl3.3b758fe3.png";